import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import SignInPage from "@/pages/SignInPage";

export const Route = createFileRoute("/sign-in")({
  head: () => pageHead("Sign in | AKIVA", "Sign in to your AKIVA portal.", "/sign-in", true),
  component: SignInPage,
});
